import { render, staticRenderFns } from "./SignInForm.vue?vue&type=template&id=a8dfbe04"
import script from "./SignInForm.vue?vue&type=script&lang=js"
export * from "./SignInForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports